<div class="help-videos-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ 'helpVideos' | translate }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
    <app-video-grid *ngIf="!loading" [videos]="videos"></app-video-grid>
  </mat-dialog-content>
</div>
